export default __webpack_public_path__ + "static/media/eye-open.755e8087.svg";